import { Outlet } from 'react-router-dom';
import PortalSidebar from './PortalSidebar';
import PortalHeader from './PortalHeader';

export default function AdminLayout() {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <PortalSidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <PortalHeader />
        <main style={{ flex: 1, overflow: 'auto', padding: '24px', background: '#f5f6fa' }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
